var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lesson"}},[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_c('Lesson',{attrs:{"lesson":_vm.lesson}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }